import styled from "styled-components";
import React from "react";
import Checkbox from "./../../Common/Components/Checkbox";
import { ReactComponent as GroupIcon } from "assets/img/icons/Group_icon.svg";
import { Typography } from "antd";

interface IModalGroupItem {
  name: string;
  userCount: number;
  onClick: any;
  checked: boolean;
  onCheckChange: any;
}

const { Paragraph } = Typography;

const ModalGroupItem: React.FC<IModalGroupItem> = (props) => {
  const { name, userCount, onClick, checked, onCheckChange } = props;
  return (
    <Wrapper onClick={onClick}>
      <div className="main">
        <div className="checkbox-styles">
          <Checkbox width={"18px"} height={"18px"} checked={checked} onChange={onCheckChange} />
        </div>
        <div className="group-logo-circle">
          <StyledGroupLogo />
        </div>
        <div className="user-count-circle">{userCount}</div>
        <Paragraph
          className="group-name"
          ellipsis={{
            rows: 1,
            tooltip: name?.trim() === "" || name === null ? name : name,
          }}
        >
          {name}
        </Paragraph>
      </div>
    </Wrapper>
  );
};

export default ModalGroupItem;

const Wrapper = styled.div`
  cursor: pointer;
  .main {
    height: 58px;
    width:310px;
    background: linear-gradient(270.13deg, rgba(255, 255, 255, 0.2) -12.87%, rgba(217, 217, 217, 0) 92.27%);
    display: flex;
    align-items: center;
  }
  .checkbox-styles {
    margin-left: 8px;
    margin-right: 1px;
    margin-top: 2px;
  }
  .group-name {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 15.7218px;
    line-height: 17px;
    letter-spacing: -0.296117px;
    color: #000000;
    margin-left: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 150px);
    margin-bottom: 0;
  }
  .user-count-circle {
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
    border-radius: 50%;
    width: 31px;
    height: 31px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16.7222px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.477778px;
    color: #000000;
    position: static;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index:0;
  }
  .group-logo-circle {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), url(people.png);
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: -5px;
    margin-left: 8px;
    z-index:1;
    background-color:#fff;
  }
`;

const StyledGroupLogo = styled(GroupIcon)`
  height: auto;
  width: 24px;
  @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    width: 20px;
  }
`;
